import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { CartDrawer } from "@/components/cart/CartDrawer";
import { trackVisit } from "@/lib/api";

function VisitTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    trackVisit(pathname);
  }, [pathname]);
  return null;
}

// L'header è fixed: il main compensa l'altezza a riposo (76px).
export function Layout({ children }) {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <VisitTracker />
      <Header />
      <main className="flex flex-1 flex-col pt-[76px]">{children}</main>
      <Footer />
      <CartDrawer />
    </div>
  );
}
